import { render, staticRenderFns } from "./MatomoConsent.vue?vue&type=template&id=6959be94"
import script from "./MatomoConsent.vue?vue&type=script&lang=js"
export * from "./MatomoConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports